import {ipssrvHost, executeGetDocsModuleDescription } from '../simbix/executer'

//Загрузка описание каталога файлов и документов (модуль docs)
// Загружается описание типов модуля docs
export const DocsModuleActions = {
    LOAD_STARTED: () => ({
        type: DocsModuleActions.LOAD_STARTED,
    }),
    LOAD_OK: description => ({
        type: DocsModuleActions.LOAD_OK,
        description
    }),
    LOAD_ERROR: () => ({
        type: DocsModuleActions.LOAD_ERROR,
    }),

    loadDescription: () => dispatch => {
        dispatch(DocsModuleActions.LOAD_STARTED());
        return executeGetDocsModuleDescription(ipssrvHost) 
            .then(response => { 
                //console.log("loadDescription", response);
                const {props, types, description} = response
                dispatch(DocsModuleActions.LOAD_OK({props, types, description}));
                return response;
            })
            .catch(e => { 
                console.error(new Error("cannot load descriptions module docs",e)); 
                dispatch(DocsModuleActions.LOAD_ERROR());
                return Promise.reject(e);
            });
    }
}
